import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { DemandeTemplate } from '..';
import { Text, Button, Input, Icon } from '../../Atoms';
import { ModalSuccessContact } from '../../Modals';
import { Upload } from '../../Molecules';
import { OrganismSelectContact } from '../../Organisms';

function TemplateContact(props) {
  
  const [resetSecondChild, doResetSecondChild] = useState(0);
  const [resetChild, doResetChild] = useState(0);
  useEffect(() => {
    doResetSecondChild(resetSecondChild + 1)
  }, [props.resetSecond]);
  useEffect(() => {
    doResetChild(resetChild + 1)
  }, [props.reset]);
  const contact = () => {
    return (
      <Row className='no-margin-mob'>
        <Col
          xs={12}
          md={{ order: 'last', sapn: 6 }}
          className='no-padding-mob container-description-contact'
        >
          <Text
            text='Une question ? Consultez notre foire aux questions !'
            className='text-contact text-bold-contact'
          />
          <Text
            text='Vous y retrouverez toutes les réponses aux questions qui nous sont le plus souvent posées.'
            className='text-contact'
          />
          <Button
            onClick={props.onClickFAQ}
            text='Consulter la FAQ'
            className='btn-consult-faq'
          />
          <div className='container-text-description-contact'>
            <Text
              text='Horaires d’ouverture : '
              className='label-contact text-bold-contact'
            />
            <Text
              text=' Du lundi au vendredi de 8h30 à 17h.'
              className='label-contact'
            />
          </div>
          <div className='container-text-description-contact'>
            <Text
              text='Numéro de téléphone : '
              className='label-contact text-bold-contact'
            />
            <Text text='  09 74 99 90 02' className='label-contact' />
          </div>
          <div className='container-text-description-contact'>
            <Text
              text='Adresse : '
              className='label-contact text-bold-contact'
            />
            <Text
              text=' 26 rue Pagès 92150 Suresnes'
              className='label-contact'
            />
          </div>
        </Col>
        <Col
          xs={12}
          md={{ order: 'first', sapn: 6 }}
          className='no-padding-mob'
        >
          <div className='container-text-description-contact'>
            <Text
              text='Une autre question ? '
              className='label-contact text-bold-contact web-display-none'
            />
            <Text
              text=' Contactez-nous grâce à notre formulaire :'
              className='label-contact web-bold font-title'
            />
          </div>
          {/* <Input
            placeholder='Inscrivez votre adresse mail'
            className='input-contact'
            onChange={e => props.onChangeContact(e.target.value, 'mail')}
          /> */}

          <OrganismSelectContact

            options={props.faqOptionsKeys}
            onChange={e => props.onSelectSubject(e)}
            value={props.state.contact.object}
            placeholder={"Sujet"}
            showText
            reset={resetSecondChild}
          />
          <OrganismSelectContact
            reset={resetChild}
            options={props.selectedFaqSubject}
            onChange={e => props.onChangeContact(e, 'question')}
            value={props.questionvalue}
            placeholder={"Veuillez sélectionner"}
            customOptionTheme={"option-select-contact-long"}
            customSelectTheme={"select-option-container-contact-long"}
          />
          <Input
            placeholder='Ecrivez votre message ici'
            as='textarea'
            className='input-contact contact-text-area'
            onChange={e => props.onChangeContact(e.target.value, 'message')}
            value={props.contact.message}
          />
          <Text
            style={{ marginBottom: '0.5rem'}}
            text={props.contact.textUpload}
            className='label-contact '
          />
          <Upload
            reset={resetSecondChild}
            style={{ height: '1px' }}
            handleFileChange={e => props.onChangeContact(e, 'file')}
            size='small'
            containerClassName='container-contact-input-file'
            files={props.contact.files}
          />
          {props.submitError.map((elem, index) => <Text
            key={index}
            className="default-error-msg"
            text={elem}
          />)}
          {/* <Text text='PDF, JPEG -  5mo maximum autorisé' className='condition-upload-doc-hospitalisation' /> */}
          <div className='container-end'>
            <Button
              disabled={props.constactDisableButton}
              text='Envoyer'
              className='btn-submit-contact'
              onClick={() => props.onSubmit()}
            />
          </div>
        </Col>
      </Row>
    );
  };
  const demande = () => {
    return (
      <DemandeTemplate
        demandeData={props.demandeData}
        demandeStep={props.demandeStep}
        viewClicked={props.viewClicked}
        selectedDemande={props.selectedDemande}
        responseClicked={props.responseClicked}
        viewDemandeClicked={props.viewDemandeClicked}
        retourClicked={props.retourClicked}
        page={props.page}
        pageNumber={props.pageNumber}
        onChangePagination={props.onChangePagination}
        demandeDataMobile={props.demandeDataMobile}
        value={props.searchWord}
        onKeyPress={props.onKeyPress}
        OnLoopIconClick={props.OnLoopIconClick}
        onChange={props.onChange}
        sortClicked={props.sortClicked}
        response={props.response}
        responseChanged={props.responseChanged}
        sendResponse={props.sendResponse}
        sendResponseMobile={props.sendResponseMobile}
      />
    );
  };
  const contactStyle = () => {
    if (props.state.status === 'Nous contacter') {
      return 'title-contact remboursement-title-active';
    }
    return 'title-contact';
  };
  const demandeStyle = () => {
    if (props.state.status === 'Mes demandes') {
      return 'title-contact remboursement-title-active';
    }
    return 'title-contact';
  };
  return (
    <div
      className='template-notification temlplate-contact template-scroll'
      onScroll={props.onScroll}
    >
      <div className='title-contact-container'>
        <Text
          text='Nous contacter'
          className={contactStyle()}
          onClick={() => props.changeStatus('Nous contacter')}
        />
        <Text
          text='Mes demandes'
          className={demandeStyle()}
          onClick={() => props.changeStatus('Mes demandes')}
        />
      </div>
      {props.state.status === 'Nous contacter' ? contact() : demande()}
      <ModalSuccessContact show={props.state.show} onHide={props.onHide} />
    </div>
  );
}
export default TemplateContact;
